<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <p v-if="question.Mandatory" v-html="question.QuestionText+'<font color=red> *</font>'"></p>
        <p v-else v-html="question.QuestionText"></p>
      </v-flex>
      <v-flex xs12 sm6>
        <v-layout row wrap>
          <v-flex xs6 sm6 md3 lg2 v-for="(image, index) in question.FileItems" :key="index">
            <div class="image_container">
              <img :src="image.ImageData" class="zoom">
              <div class="after faded">
                <p class="black--text full text-left">
                  <v-btn icon color="warning" @click="removeFile(index)">
                    <v-icon>cancel</v-icon>
                  </v-btn>
                </p>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-input
            :rules="[question.Mandatory ? rules.requiredItems : true]"
            :required="question.Mandatory"
            :value="question.FileItems">
          <div class="d-flex flex-column align-center">
            <v-layout>
            <v-flex xs12 sm6>
              <v-btn block color="primary" dark class="mb-2" @click="onPickFile"> {{ $t("Camera") }}</v-btn>
            </v-flex>
            <v-flex xs12 sm6>
              <v-btn block color="primary" dark @click="onTakePhoto"> {{ $t("Gallery") }} </v-btn>
            </v-flex>
            </v-layout>
          </div>
          </v-input>
          <input type="file" ref="image" name="image" accept="image/*" capture="environment" @change="onFilePicked">
          <input type="file" ref="image2" name="image" accept="image/*" @change="onFilePicked">
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import rules from '@/core/mixins/common-rules'
import mediumZoom from 'medium-zoom'
import { readAndCompressImage } from 'browser-image-resizer'

export default {
  mixins: [rules],
  props: ['question'],
  components: {},
  data () {
    return {
      accept: 'image/*',
      authentication: true, // Determines if acceptedFileTypes should prevent submissions from files without those endings
      acceptedFileTypes: ['png', 'jpg', 'jpeg']
    }
  },
  mounted () {
    mediumZoom(
      Array.from(document.querySelectorAll('.zoom')).filter(
        img => !img.classList.contains('medium-zoom-image')
      )
    )
  },
  methods: {
    onPickFile () {
      this.$refs.image.click()
    },
    onTakePhoto () {
      this.$refs.image2.click()
    },
    async onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files

      this.question.buzy = true
      try {
        if (files && files[0]) {
          const file = await readAndCompressImage(files[0], {
            quality: 0.6,
            maxWidth: 1600,
            maxHeight: 1600
          })

          const filename = files[0].name
          const regex = new RegExp(
            '.' + this.acceptedFileTypes.join('|') + '$',
            'i'
          )
          if (this.authentication) {
            if (filename && !filename.match(regex)) {
              this.$root.$message.showError(this.$t('File must be an image (jpg or png)'))
              event.target.value = ''
              this.question.buzy = false
              return
            }
          }
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            this.question.FileItems.push({ ImageData: fileReader.result, NameOfFile: filename })

            this.$nextTick(() => {
              mediumZoom(
                Array.from(document.querySelectorAll('.zoom')).filter(
                  img => !img.classList.contains('medium-zoom-image')
                )
              )
            }, 0)

            this.question.buzy = false
          })
          fileReader.readAsDataURL(file)
        } else {
          this.$store.dispatch('notify', {
            message: 'No file provided',
            color: 'error'
          })
          event.target.value = ''
        }
      } catch {
        this.question.buzy = false
      }
    },
    removeFile (index) {
      this.question.FileItems.splice(index, 1)
    }
  }
}
</script>

<style scoped>
input[type='file'] {
  position: absolute;
  left: -99999px;
}
.image_container {
  position: relative;
  display: inline-block;
  text-align: center;
}
.image_container img {
  max-width: 100%;
}
.image_container .after {
  position: absolute;
  top: 0;
  left: 0;
}
.faded {
  opacity: 0.75;
}
</style>
